// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: rgba(0, 0, 0, 0.9) 0% 0% no-repeat padding-box;

  color:rgba(255, 255, 255, 1);
  opacity: 1;

  margin: 0;
  padding: 0;
}

.main {
  background: rgba(16, 16, 16, 0.8) 0% 0% no-repeat;
  opacity: 1;
}

label, p {
  color: rgba(255, 255, 255, 1);
}

div, button, span, form {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/layout.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;;EAE1D,4BAA4B;EAC5B,UAAU;;EAEV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["body {\n  background: rgba(0, 0, 0, 0.9) 0% 0% no-repeat padding-box;\n\n  color:rgba(255, 255, 255, 1);\n  opacity: 1;\n\n  margin: 0;\n  padding: 0;\n}\n\n.main {\n  background: rgba(16, 16, 16, 0.8) 0% 0% no-repeat;\n  opacity: 1;\n}\n\nlabel, p {\n  color: rgba(255, 255, 255, 1);\n}\n\ndiv, button, span, form {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
